<template>
  <div>
    <div class="box pay_bg" :style="topStyle" :class="{mt0: ori_str == 'continueEdu'}">
      <div class="wrap w1200  pay_b">
        <div class="wx-pay-container">
          <div class="wx-pay-top">
            <div class="wx-pay-subject"><b class="title-separation-line">|&nbsp;&nbsp;&nbsp;&nbsp;</b>{{subject}}</div>
            <div class="wx-pay-title">
              <label>提交成功, 请尽快支付!</label>
            </div>
          </div>
          <div class="wx-pay-content">
            <div class="wx-pay-content-price">
              应付金额: <span class="price">{{parseFloat(money).toFixed(2)}}</span>元
            </div>
            <div class="wx-pay-content-mid">
              <div class="wx-pay-title">扫一扫付款(元)</div>
              <div class="wx-qrcode-container">
                <div id="qrcode" class="wx-pay-qrcode"></div>
                <img src="@/assets/images/wxCode.png" alt="">
                <div class="wx-pay-content-guide">
                  <img src="@/assets/images/wxCodeGuide.png" alt="支付指导">
                </div>
              </div>
              <div class="wx-pay-title">
                <label>支付完成前请不要关闭页面</label>
              </div>
              <div class="wx-pay-title">
                <div v-if="errMsg">{{errMsg}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    components: { },
    data () {
      return {
        businessId: this.$route.query.businessId,
        type: this.$route.query.type,
        money: this.$route.query.money,
        subject: this.$route.query.subject,
        url: this.$route.query.qrCode,
        returnUrl: this.$route.query.returnUrl,
        domainHref: this.$route.query.domainHref,
        sign: this.$route.query.sign,
        errMsg: '',
        timer: 0,
        ori_str: ''
      }
    },
    created () {
      this.ori_str = window.location.hash.split('/')[1]
    },
    mounted () {
      this.$nextTick(() => {
        this.generateQRCode(this.url)
        this.getPayResultTimer()
      })
    },
    computed: {
      ...mapState('auth', ['user']),
      topStyle () {
        if (this.ori_str == 'entrain') {
          return {
            marginTop: '121px'
          }
        }
        return {}
      }
    },
    methods: {
      generateQRCode (url) {
        $(function () {
          $('#qrcode').qrcode({
            render: "table",
            width: 150,
            height: 150,
            text: url
          });
        })
      },
      getPayResult (type, businessId) {
        this.$api.post(this.$global.paymentApiPath, '/paycenter/getPayState', {businessId: businessId}, r => {
          if (r.data) {
            let result = r.data;
            if (result.payResult == '1') { // 支付成功
              let redirectUrl = this.returnUrl + '/' + type + '/' + businessId + '/' + encodeURIComponent(this.domainHref)
              window.location.replace(redirectUrl)
            } else if (result.payResult == '0') {
              this.errMsg = '支付中...';
            }
          }
        })
      },
      getPayResultTimer () {
        var that = this
        this.timer = window.setInterval(function () {
          that.getPayResult(that.type, that.businessId);
        }, 3000);
      }
    },
    beforeDestroy () {
      clearInterval(this.timer)
    }
  }
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/page/modules/pay/wxPay.vue